import type { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const Exchange = () => import('@/modules/exchange/pages/Exchange/index.vue');

const multiTransactionRoutes: Array<RouteRecordRaw> = [
  {
    path: '/exchange',
    name: 'exchange',
    redirect: {
      name: 'exchange-index',
    },
    component: EmptyLayout,
    meta: {
      accessRol: {
        section: 'WALLET',
        actions: ['EXCHANGE'],
      },
    },
    children: [
      {
        path: '',
        name: 'exchange-index',
        component: Exchange,
      },
    ],
  },
];

export default multiTransactionRoutes;
